import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import PropertyListEditor from 'components/PropertyListEditor/PropertyListEditor';
import type { FC } from 'react';
import StaticField from '../../../FieldEditorControls/StaticField';

interface IConstraintItem {
  type: string;
  persistedValue: {};
  validatorProperties: {};
  locked?: boolean;
  index: string;
  onRemove: (index: string) => void;
  onValueChange: (key: Array<string>, value: string | number | boolean | undefined | {}) => void;
  onDeleteProperty?: (key: Array<string>) => void;
  owner?: any;
}
const ConstraintItem: FC<IConstraintItem> = ({
  type,
  validatorProperties,
  persistedValue,
  locked,
  index,
  onValueChange,
  onRemove,
  onDeleteProperty,
  owner
}) => (
  <FlexLayout
    width="full"
    p="sm"
    bg="panelLight"
    flexWrap="nowrap"
    borderRadius="small"
    mb="xs"
    css={{
      ':hover': {
        '#delete-processor': {
          opacity: 1
        }
      }
    }}
  >
    <FlexLayout flexDirection="column" alignItems="center" mr="xs">
      <FlexLayout
        p="xs"
        mb="sm"
        bg="white"
        alignItems="center"
        justifyContent="center"
        border="regular"
        borderColor="secondary"
        style={{ width: '32px', height: '32px', borderRadius: '50%' }}
      >
        <H4 color="secondary" fontSize="sm">
          {index}
        </H4>
      </FlexLayout>
      {locked !== true && (
        <Icon
          id="delete-processor"
          src="deleteOutline"
          color="primary"
          stroke="transparent"
          opacity="none"
          style={{ cursor: 'pointer', transition: 'opacity .2s ease-in-out' }}
          onClick={() => onRemove(index)}
        />
      )}
    </FlexLayout>
    <FlexLayout flexDirection="column" width="full">
      <StaticField property="type" value={type} />
      <FlexLayout>
        <PropertyListEditor
          propertyList={validatorProperties}
          data={persistedValue}
          owner={owner}
          locked={locked}
          onChange={onValueChange}
          onDelete={onDeleteProperty}
        />
      </FlexLayout>
    </FlexLayout>
  </FlexLayout>
);

export default ConstraintItem;
